/* eslint-disable react/prop-types, react/destructuring-assignment */
import clsx from 'clsx'
import moment from 'moment'
import React, { useState } from 'react'
import { Button, Col, Dropdown, Form, Row } from 'react-bootstrap'
import { FormattedMessage, injectIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import { addApplicationNote, deleteApplicationNote, editApplicationNote } from '../crud/elastic.crud'
import Spinner from '../partials/content/Spinner'

function CompanyDetailsNotes(props) {
  const { customer, application, notes, showNotes } = props

  const currentUser = useSelector(({ user }) => user.data)

  // State Properties
  const [applicationDetailsNotes, setApplicationDetailsNotes] = useState(notes || [])
  const allowPermissions = useSelector(({ userPermissions }) => userPermissions.data.permissions)
  const hasManagePermission = allowPermissions.discover === 'manage'
  const [isAddEditMode, setIsAddEditMode] = useState(false)
  const [addEditNote, setAddEditNote] = useState('')
  const [note, setNote] = useState('')
  const [hasNote, setHasNote] = useState(false)
  const [isSavingNote, setIsSavingNote] = useState(false)

  // Constants
  const MAX_NOTE_LENGTH = 256

  // Events
  const onAddNote = () => {
    setAddEditNote({
      note: '',
      dateModified: moment(),
      userName: `${currentUser.first_name} ${currentUser.last_name}`,
      userId: currentUser.id,
    })
    setNote('')
    setIsAddEditMode(true)
  }

  const onEditNote = (noteObject) => {
    setAddEditNote(noteObject)
    setNote(noteObject.note)
    setHasNote(noteObject.note.length > 0)
    setIsAddEditMode(true)
  }

  const onDeleteNote = async (noteObject) => {
    setIsSavingNote(true)

    try {
      await deleteApplicationNote(application, customer, noteObject)
      setApplicationDetailsNotes(
        // eslint-disable-next-line no-shadow
        applicationDetailsNotes.filter((note) => note.id !== noteObject.id),
      )
    } catch (error) {
      console.error('[onDeleteNote] - Failed to delete an application note: ', error)
    }

    setIsSavingNote(false)
  }

  const onCancelNote = () => {
    setHasNote(false)
    setIsAddEditMode(false)
  }

  const onSaveNote = async () => {
    setIsSavingNote(true)

    try {
      addEditNote.note = note

      // Create a new note
      if (!addEditNote.id) {
        const response = await addApplicationNote(application, customer, addEditNote)

        applicationDetailsNotes.push(response.data)
      } else {
        // Update an existing note
        addEditNote.dateModified = moment()
        const response = await editApplicationNote(application, customer, addEditNote)

        // eslint-disable-next-line no-shadow
        applicationDetailsNotes.map((note) => {
          if (addEditNote.id === note.id) {
            return response.data
          }
          return note
        })
      }
      setApplicationDetailsNotes(applicationDetailsNotes)
      setIsAddEditMode(false)
    } catch (error) {
      console.error(error)
    }

    setIsSavingNote(false)
  }

  // Note Actions component
  // eslint-disable-next-line react/no-unstable-nested-components, no-shadow
  function NoteActions(props) {
    return (
      <div className="actions">
        <Dropdown drop="down" align="end" size="sm">
          <Dropdown.Toggle className="none-after" variant="btn" id="dropdownToggleNote">
            <i className="flaticon-more-1" />
          </Dropdown.Toggle>
          <Dropdown.Menu className="dropdown-menu-fit dropdown-menu-end dropdown-menu-anim dropdown-menu-top-unround">
            <ul className="nav margin-t-10 margin-b-10">
              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */}
              <li
                className={clsx('nav__item')}
                data-bs-toggle="collapse"
                onClick={() => {
                  onEditNote(props.item)
                }}
              >
                <span className={clsx('nav__link')}>
                  <span className="nav__link nav__link-text">
                    <FormattedMessage id="GENERAL.EDIT" />
                  </span>
                </span>
              </li>
              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */}
              <li
                className={clsx('nav__item')}
                data-bs-toggle="collapse"
                onClick={() => {
                  onDeleteNote(props.item)
                }}
              >
                <span className={clsx('nav__link')}>
                  <span className="nav__link nav__link-text">
                    <FormattedMessage id="GENERAL.DELETE" />
                  </span>
                </span>
              </li>
            </ul>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    )
  }

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {showNotes && customer?.id && (
        <>
          <hr />
          <p className="font-bolder">
            <FormattedMessage id="NOTES.NOTES" />
          </p>
          {isSavingNote && (
            <div className="col-md-12">
              <div className="flex">
                <Spinner />
              </div>
            </div>
          )}
          {!isSavingNote &&
            !isAddEditMode &&
            applicationDetailsNotes
              ?.sort((a, b) => moment(a.dateModified) - moment(b.dateModified))
              .map((item) => (
                <div style={{ marginTop: '0', marginBottom: '1rem' }} key={`note_${item.id}`}>
                  <Row>
                    <Col>
                      <Row style={{ lineHeight: '2.5' }}>
                        <Col>
                          <span>
                            {item.userName}
                            <span style={{ width: '100%', color: 'var(--bs-secondary-color)' }}>
                              - {moment(item.dateModified).format('DD/MM/YYYY')}
                            </span>
                          </span>
                        </Col>
                        <Col>
                          {item.user === currentUser.id && (
                            <div className="float-end">
                              <NoteActions item={item} />
                            </div>
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div
                        style={{
                          padding: '10px',
                          backgroundColor: 'var(--bs-tertiary-bg)',
                          border: '1px solid var(--bs-border-color)',
                          borderRadius: '3px',
                        }}
                      >
                        <span style={{ wordWrap: 'break-word', color: 'var(--bs-secondary-color)' }}>{item.note}</span>
                      </div>
                    </Col>
                  </Row>
                </div>
              ))}

          {!isSavingNote && isAddEditMode && (
            <div style={{ marginTop: '0', marginBottom: '1rem' }}>
              <Row>
                <Col>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={note}
                    style={{ resize: 'none' }}
                    onChange={(event) => {
                      if (event.target.value.length <= MAX_NOTE_LENGTH) {
                        setNote(event.target.value)
                      }
                      setHasNote(!!event.target.value.length)
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="mt-2">
                  <Button onClick={onCancelNote} variant="light" size="sm" className="me-2">
                    <FormattedMessage id="GENERAL.CANCEL" />
                  </Button>
                  <Button variant="primary" size="sm" onClick={onSaveNote} disabled={!hasNote}>
                    <FormattedMessage id="GENERAL.SAVE" />
                  </Button>
                </Col>
                <Col>
                  <div className="float-end">
                    <span style={{ color: 'var(--bs-secondary-color)' }}>
                      {note.length}/{MAX_NOTE_LENGTH}
                    </span>
                  </div>
                </Col>
              </Row>
            </div>
          )}

          {hasManagePermission && !isSavingNote && !isAddEditMode && (
            <p>
              <Button variant="link" className="ps-0" onClick={onAddNote}>
                <span className="flaticon2-plus icon font-primary" style={{ fontSize: '1rem' }}>
                  <span className="ms-1 font-primary">
                    <FormattedMessage id="NOTES.ADD_NOTE" />
                  </span>
                </span>
              </Button>
            </p>
          )}
        </>
      )}
    </>
  )
}

export default injectIntl(CompanyDetailsNotes)
